import { render, staticRenderFns } from "./ReservationLayout.vue?vue&type=template&id=735cd84c"
import script from "./ReservationLayout.vue?vue&type=script&lang=js"
export * from "./ReservationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports